import { createStore } from "vuex";
import AppModule from "./app.module";

export default createStore({
    modules: {
        app: AppModule,
    },
});
